import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { Store } from "@ngxs/store";
import { CommentDto } from "../../../../permit-details/models/permit-comments-dto";
import { PermitDetailsActions } from "../../../../permit-details/states/permit-details.action";

@Component({
    selector: "pmt-permit-comments-comment",
    templateUrl: "permit-comments-comment.component.html",
    styleUrls: ["permit-comments-comment.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitCommentsCommentComponent {
    @Input()
    public comment: CommentDto;

    @Input()
    public canDelete: boolean;

    constructor(private store: Store) {}

    public remove() {
        this.store.dispatch(new PermitDetailsActions.RemoveComment(this.comment));
    }
}
